import { useNavigate } from 'react-router-dom';
import * as S from './ModalStyle';

interface ModalProps {
  onClose: () => void;
}

export default function CancelComplete({ onClose }: ModalProps) {
  const navigate = useNavigate();
  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalTitle>예약 취소 완료</S.ModalTitle>
        <S.ModalContent>
          <S.Summary>
            2025 목포해상W쇼 입장권
            <br />
            사전예약이 정상 취소되었습니다.
          </S.Summary>
          <S.Summary>시간 내어 취소해주셔서 감사합니다.</S.Summary>
          <S.AskMethod>
            *입장권 관련 문의: <br />
            <a
              href="https://pf.kakao.com/_Ixexiwn"
              style={{ textDecoration: 'underline' }}
            >
              https://pf.kakao.com/_Ixexiwn
            </a>
          </S.AskMethod>
        </S.ModalContent>
        <S.CloseButton
          type="button"
          onClick={() => {
            onClose();
            navigate('/');
          }}
        >
          확인
        </S.CloseButton>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
